// extracted by mini-css-extract-plugin
module.exports = {"item":"index_item_cO3uM","icon":"index_icon_2Hugy","title":"index_title_2bWNA","line":"index_line_3UNR1"};